jQuery(document).ready(function() {
  jQuery('.js-select2').select2({
    selectionCssClass: 'select2__section',
    dropdownCssClass: 'select2__dropdown',
    minimumResultsForSearch: Infinity
  });
});

jQuery(document).ready(function() {
  jQuery('.js-select2-list').select2({
    selectionCssClass: 'select2__section-list',
    dropdownCssClass: 'select2__dropdown-list',
    minimumResultsForSearch: Infinity
  });
});

jQuery(document).ready(function() {
  jQuery('.js-select2-mobile').select2({
    selectionCssClass: 'select2__section-mobile',
    dropdownCssClass: 'select2__dropdown-mobile',
    minimumResultsForSearch: Infinity
  });
});
